<app-navigation></app-navigation>
<router-outlet (activate)="resetPosition();">
  <app-cookie-consent></app-cookie-consent>
</router-outlet>
<app-footer></app-footer>
